module.exports = __webpack_public_path__ + "static/img/bg.0c603b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 3